import Image from 'next/image';
import React from 'react';
interface IData {
  title: string;
  cards: {
    title: string;
  }[];
}

export default function StepCard({ data }: { data: IData }) {
  const { title, cards } = data;
  return (
    <section className="step-card-section max-w-[1240px] mx-auto primary-text px-4 mt-14">
      <h2 className="text-center font-bold text-4xl max-md:text-xl leading-[1]">{title}</h2>
      <div className="flex justify-between gap-10 pt-16 max-md:pt-8 max-lg:flex-col">
        {cards.map((item: any, index: number) => (
          <div key={index} className="flex-1 flex bg-[#EAEEFA] rounded-[16px] overflow-hidden">
            <div className="p-5 flex-1">
              <div className="text-[#725CFF] text-[28px] max-md:text-base font-bold">{index + 1}</div>
              <h3 className="font-semibold max-md:text-sm pt-4 max-md:pt-2">{item.title}</h3>
              <div className="pt-3 text-xs primary-text-60">{item.desc}</div>
            </div>
            <Image
              src={`/images/guide/${index + 1}.png`}
              alt={item.title}
              width={148}
              height={204}
              className="max-md:w-[108px]"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
